module.exports = __webpack_public_path__ + "static/img/fwjyrzdj.e01db878.png";